<template>
  <div class="motor-cover-start">
    <label class="input-label">Cover start date <span class="req">*</span></label>
    <v-text-field
      :value="value"
      :min="minDate"
      :max="maxDate"
      type="date"
      outlined
      dense
      hide-details="auto"
      class="custom-input"
      @input="$emit('input', $event)"
    />
    <div v-if="showNextYearWarning" class="cover-start-disclaimer">
      <v-icon x-small color="#92400E" class="tw-mr-1">mdi-alert-circle</v-icon>
      Next-year policy — manual review required by Underwriting Team
    </div>
  </div>
</template>

<script>
import {
  minCoverStartDate, maxCoverStartDate, isNextYearCoverStart,
} from '@/utils/motorCoverDates';

export default {
  name: 'MotorCoverStartField',
  props: {
    value: { type: String, default: '' },
  },
  computed: {
    minDate() {
      return minCoverStartDate();
    },
    maxDate() {
      return maxCoverStartDate();
    },
    showNextYearWarning() {
      return isNextYearCoverStart(this.value);
    },
  },
};
</script>

<style scoped lang="scss">
.cover-start-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  font-size: 0.72rem;
  color: #92400e;
  line-height: 1.4;
}
</style>
